import React, { useState, useEffect } from "react"
import { graphql, useStaticQuery } from "gatsby"

import { MainMenu } from "./main-menu"
import Logo from "../../BrandLogo"

import "./header.css"

const Header = ({ className = "", isHeaderDark, languagePreference }) => {
  let data = useStaticQuery(graphql`
    query {
      allContentfulPage(
        sort: { fields: menuSequence, order: ASC }
      ) {
        nodes {
          id
          slug
          pageHeaderLink
          useFirstChildLink
          isIncludedInMenu
          menuNameTranslation {
            title
            description {
              description
            }
          }
          pageTitle
          pageSubTitle
          submenuPage
          submenuSequence
          parentMenuName,
          parentMenuOption,
          headerMegaMenu {
            secondaryLevelMenu {
              slug
              pageTitle
            }
            tertiaryLevel {
              buttonName,
              buttonLink
            }
          }
        }
      }
    }
  `)

  const [isToggleMenu, setToggleMenu] = useState(false)

  const toggleMenu = () => {
    setToggleMenu(!isToggleMenu)
  }

  useEffect(() => {
    if (isToggleMenu) {
      document.documentElement.classList.add("html--menu-open");
    } else {
      document.documentElement.classList.remove("html--menu-open");
    }

    return () => {
      document.documentElement.classList.remove("html--menu-open");
    };
  }, [isToggleMenu]);

  const menuItems = data.allContentfulPage.nodes.filter(
    (page) =>
      page.isIncludedInMenu === true
  );

  return (
    <header
      className={`main-header justify-between align-center flex mx-auto ${className} ${isToggleMenu && 'header--open'}`}
    >
      <Logo href="/" title="Savor Brands Logo" isDarkMode={isToggleMenu ? true : isHeaderDark ? isHeaderDark : false} />
      <MainMenu
        menuItems={menuItems}
        hideDesktopMenuClass="hide-md"
        showMobileMenuClass="hide-min-lg"
        isToggleMenu={isToggleMenu}
        toggleAction={toggleMenu}
        isHeaderDark={isHeaderDark}
        languagePreference={languagePreference}
      />
    </header>
  )
}

export default Header
